import React, { useState, useEffect } from "react";
import Layout from '../form-layout'

export default function Step5({ formData, setFormData, goToStep ,onBack }) {
  const [ethnicity, setEthnicity] = useState(
    formData.ethnicity || localStorage.getItem("ethnicity") || ""
  );

  const options = [
    "White",
    "Asian or British Asian",
    "Black, Black British, African, or Caribbean",
    "Arab",
    "Mixed",
    "Prefer not to say",
    "Other"
  ];

  useEffect(() => {
    const saved = localStorage.getItem("ethnicity");
    if (saved) {
      setEthnicity(saved);
      setFormData((prev) => ({ ...prev, ethnicity: saved }));
    } else {
      setEthnicity(formData.ethnicity || "");
    }
  }, [formData.ethnicity, setFormData]);

  const handleSelect = (value) => {
    setEthnicity(value);
    setFormData({ ...formData, ethnicity: value });
    localStorage.setItem("ethnicity", value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!ethnicity) return;
    goToStep("8");
  };

  return (
    <Layout goToStep={goToStep} onBack={onBack}>
      <div className="bg-white shadow-sm w-full max-w-xl px-6 sm:px-8 pb-40 rounded-2xl mx-auto my-10">

        {/* Heading */}
        <p className="text-sm sm:text-[14px] font-medium text-[#000000] mb-6 leading-relaxed">
          What is your ethnicity? Please select one option below.
        </p>

        {/* Options */}
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          {options.map((option) => {
            const isSelected = ethnicity === option;
            return (
              <label
                key={option}
                className={`flex items-center cursor-pointer p-4 rounded-lg border-2 transition-colors
    `}
                onClick={() => handleSelect(option)}
              >
                <input
                  type="radio"
                  name="ethnicity"
                  value={option}
                  checked={isSelected}
                  onChange={() => handleSelect(option)}
                  className="h-4 w-4 accent-[#35C3D9] mr-3"
                />
                <span className="text-sm sm:text-[14px] font-medium text-[#000000] ">{option}</span>
              </label>

            );
          })}

          {/* Next Button */}
          <div className="text-start pt-6">
            <button
              type="submit"
              disabled={!ethnicity}
              className={`w-[210px] text-sm font-semibold rounded-lg py-3 transition-colors
                ${ethnicity ? "bg-[#35C3D9] text-white hover:bg-[#27AAC0]" : "bg-gray-300 text-gray-600 cursor-not-allowed"}`}
            >
              Next →
            </button>
          </div>
        </form>
      </div>
    </Layout>
  );
}
